export enum Module {
    Defect = 1,
    Correction,
    Foresight,
    Configuration,
    Tests,
    Requirement,
    Feature,
    Task,
    Issues,
    Development,
    TestTree,
    ForesightAllComponents,
    UnifiedProjectPlan
}
